const primaryNavLi = document.querySelectorAll('.nav-primary li.menu-item-has-children > a')
const dropdownClass = 'dropdown-active';
let selectedNavElement

primaryNavLi.forEach(e => {
    e.addEventListener('click', e => {
        e.preventDefault()
        e.stopPropagation()

        selectedNavElement = e.target.closest('li')
        selectedNavElement.classList.toggle(dropdownClass)

        // check if there are others currently active dropdowns and close them
        // we compare each found element is it currently clicked one
        const activeDropdown = document.querySelectorAll(`.nav-primary .${dropdownClass}`)
        activeDropdown.forEach(e => {
            if ( !e.isSameNode(selectedNavElement) ) {
                e.classList.remove(dropdownClass)
            }
        })
    })
})
